<template>
  <div>
    <div class="profile-edit__box-image js-sortable-images">
      <div
        v-if="avatar"
        class="profile-edit__avatar"
        :class="avatar.verified_at ? false : 'profile-edit__photo--check'"
        style="background-repeat: no-repeat; background-size: cover; background-position: center center"
        v-bind:style="{ 'background-image': 'url(' + avatar.url + ')' }"
      >
        <div
          class="js-image-edit-modal profile-edit__photo-edit"
          @click.prevent="$eventHub.$emit('EditImageModalOpen', avatar)"
          data-can-edit="false"
        ></div>
      </div>
      <div
        v-else
        class="profile-edit__avatar"
        style="background-repeat: no-repeat; background-size: cover; background-position: center center"
        v-bind:style="{ 'background-image': 'url(' + user.web_avatar_url + ')' }"
      ></div>

      <div
        v-for="(image, index) in visibleImages"
        :key="index"
        :class="{'profile-edit__photo--price': image.price , 'profile-edit__photo js-sortable-element':image.verified_at, 'profile-edit__photo profile-edit__photo--check': !image.verified_at}"
        style="background-repeat: no-repeat; background-size: cover; background-position: center center"
        v-bind:style="{ 'background-image': 'url(' + image.url + ')' }"
      >
        <div
          class="js-image-edit-modal profile-edit__photo-edit"
          @click.prevent="$eventHub.$emit('EditImageModalOpen', image)"
          :data-url="`route('front.profile.update_image', ${image.id})`"
          :data-delete-url="`route('front.media.delete', ${image.uuid})`"
          :data-image="image.image_url"
          :data-price="image.price"
        ></div>
        <div v-if="image.price" class="profile-edit__photo-price">{{ image.price }} <i
          class="demo-icon icon-n-lova-coins"
        ></i></div>
      </div>

      <template v-if="showMore">
        <div
          v-for="(image, index) in hiddenImages"
          :key="index"
          class="profile-edit__photo js-sortable-element"
          style="background-repeat: no-repeat; background-size: cover; background-position: center center"
          v-bind:style="{ 'background-image': 'url(' + image.url + ')' }"
          :class="{ 'profile-edit__photo--price': image.price }"
        >
          <div
            class="js-image-edit-modal profile-edit__photo-edit"
            @click.prevent="$eventHub.$emit('EditImageModalOpen', image)"
            :data-url="`route('front.profile.update_image', ${image.id})`"
            :data-delete-url="`route('front.media.delete', ${image.uuid})`"
            :data-image="image.image_url"
            :data-price="image.price"
          ></div>
          <div v-if="image.price" class="profile-edit__photo-price">{{ image.price }} <i
            class="demo-icon icon-n-lova-coins"
          ></i></div>
        </div>
      </template>

      <div
        @click.prevent="$eventHub.$emit('NewImageModalOpen'); hasHighlight = false;"
        class="js-image-add-modal profile-edit__add-photo"
        :class="{ 'element-highlight': hasHighlight }"
      >
        <div class="profile-edit__add-photo-label">
          {{ trans.get('profile:edit.add_photo_button') }}
        </div>
      </div>
    </div>
    <div v-if="hiddenImages.length" class="profile-edit__photo-collapse">
      <div class="profile-edit__photo-collapse-divider"></div>

      <button @click="toggleShowMore" class="button button--tight button__outline mb-4">
        <span v-if="showMore">{{ trans.get('profile:edit.less_photos_button') }}</span>
        <span v-else>{{ trans.get('profile:edit.more_photos_button') }} (+{{ hiddenImages.length }})</span>
      </button>
    </div>
  </div>
</template>

<script>
import HighlightMixin from '../../../front/components/User/HighlightMixin';

export default {
  name: 'GalleryComponent',
  mixins: [HighlightMixin],
  components: {},
  props: {
    user: Object,
  },
  data() {
    return {
      avatar: null,
      images: [],
      imagesNotVerified: [],
      showMore: false,
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    showedSlotsNumber() {
      if (this.windowWidth <= 650) {
        return 4;
      } else if (this.windowWidth <= 1400) {
        return 9;
      } else if (this.windowWidth <= 1700) {
        return 15;
      } else {
        return 25;
      }

    },
    allImages() {
      return this.imagesNotVerified.concat(this.images);
    },
    visibleImages() {
      return this.allImages.slice(0, this.showedSlotsNumber);
    },
    hiddenImages() {
      return this.allImages.slice(this.showedSlotsNumber);
    }
  },
  methods: {
    loadMedia: function () {
      axios // api request for media
        .get(zRoute('ajax.user.media.index'), this.form)
        .then((response) => {
          const media = response.data.data;

          this.avatar = media.find((m) => {
            return m.collection_name === 'avatars';
          });

          this.images = media.filter((m) => {
            return m.collection_name !== 'avatars' && m.verified_at !== null;
          });

          this.imagesNotVerified = media.filter((m) => {
            return m.collection_name !== 'avatars' && m.verified_at === null;
          });
        });
    },
    toggleShowMore() {
      this.showMore = !this.showMore;
    },
  },
  mounted() {
    this.loadMedia();

    this.$eventHub.$on('FreshGallery', () => {
      this.loadMedia();
    });
  },
};
</script>


